import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ErrorMessage, Field } from 'formik';
import { isEmpty } from 'lodash';
import { parsePhoneNumberLink, price } from 'utils/helpers';
import StepperField from 'components/formik/stepper_field/stepper_field';
import {
  getPricePerPaxType,
  getProductPassengerTypes,
} from 'redux/selectors/booking_form';

export const renderPassengerTypes = (
  passengerTypeIDs,
  selectedResourceId,
  selectedDate,
  title = 'Passengers',
  message = null,
  isGiftVoucher = false
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const passengerTypes = useSelector((state) =>
    getProductPassengerTypes(state, { passengerTypeIDs })
  );

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const cmsPassengerTypes = useSelector(
    (state) => state.types.cmsPassengerTypes
  );

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const pricePerPaxType = useSelector((state) =>
    getPricePerPaxType(state, { selectedResourceId, selectedDate })
  );

  if (isEmpty(passengerTypeIDs) || isEmpty(passengerTypes)) {
    return null;
  }

  const renderPrice = (id) => {
    if (isEmpty(pricePerPaxType)) {
      return null;
    }

    const priceInCents = pricePerPaxType[id];
    if (priceInCents === undefined) {
      return null;
    }

    return <span className="mt-1 text-xx-small">({price(priceInCents)})</span>;
  };

  return (
    <div
      className={`booking-flow__pax-wrapper${isGiftVoucher ? ' d-none' : ''}`}
    >
      <div className="booking-flow__pax-title">{title}</div>

      <div className="booking-flow__pax-selections space-y-5">
        {passengerTypeIDs.map((passengerTypeID) => {
          const passengerType = passengerTypes[passengerTypeID];
          const { id } = passengerType;
          let { name, conditions } = passengerType;

          if (cmsPassengerTypes) {
            const cmsPassengerType = cmsPassengerTypes.find(
              (type) => Number(type.id) === Number(passengerTypeID)
            );

            name = cmsPassengerType?.label || name;
            conditions = cmsPassengerType?.conditions || conditions;
          }

          return (
            <div key={`passengerType.${name}`}>
              <div className="pax__row">
                <div className="d-flex align-items-center">
                  <label className="mb-0" htmlFor={`passengers.${id}`}>
                    <span className="fw-bold">{name}</span> {renderPrice(id)}
                  </label>
                  {conditions && (
                    <OverlayTrigger
                      placement="bottom"
                      trigger="click"
                      rootClose="true"
                      overlay={<Tooltip>{conditions}</Tooltip>}
                    >
                      <i
                        role="button"
                        className="fas fa-question-circle mx-2 text-primary"
                      />
                    </OverlayTrigger>
                  )}
                </div>
                <div className="pax__stepper">
                  <Field component={StepperField} name={`passengers.${id}`} />
                </div>
              </div>
              <ErrorMessage
                name={name}
                component="div"
                className="text-danger text-x-small mt-3"
                id={`error-passenger-type-${name}`}
              />
            </div>
          );
        })}
        <ErrorMessage
          name="passengers"
          component="div"
          className="text-danger text-x-small mt-1"
          id="error-passengers"
        />
      </div>
      {!isEmpty(message) && (
        <div className="alert alert-info text-small">
          <i className="fas fa-info-circle me-1" />
          {parsePhoneNumberLink(message)}
        </div>
      )}
    </div>
  );
};
